<template>
  <div class="CouponManager">
    <STable
      ref="tableref"
      method="post"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="100px"
    />
    <el-dialog
      v-if="dialogVisible==='修改'"
      v-dialogDrag
      title="优惠券修改"
      :visible.sync="editDialog"
      :close-on-click-modal="false"
      :before-close="cancel"
      width="50%"
      center
    >
      <div style="width: 90%;margin:0 auto">
        <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="90px">
          <el-form-item label="优惠券库存" prop="stock">
            <el-input v-model="editForm.stock" placeholder="请输入库存" />
          </el-form-item>
          <el-form-item label="使用说明" prop="reason">
            <el-input v-model="editForm.detail" type="textarea" :rows="4" placeholder="请输入使用说明" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="editSubmit()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogVisible==='作废'"
      v-dialogDrag
      title="优惠券作废"
      :visible.sync="voidDialog"
      :close-on-click-modal="false"
      :before-close="cancel"
      width="50%"
      center
    >
      <div style="width: 90%;margin:0 auto">
        <el-form ref="voidFormRef" :model="voidForm" :rules="voidRules" label-width="80px">
          <el-form-item label="作废原因" prop="reason">
            <el-input v-model="voidForm.cancelledDetail" type="textarea" :rows="4" placeholder="请输入作废原因" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="voidSubmit()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogVisible==='成本核算'"
      v-dialogDrag
      title="成本核算"
      :visible.sync="accountDialog"
      :close-on-click-modal="false"
      :before-close="cancel"
      width="50%"
      center
    >
      <STable
        ref="accountRef"
        :url="accountUrl"
        :columns="accountColumns"
        :selection="false"
        :is-show-page="false"
        label-width="100px"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CouponManager',
  data() {
    return {
      isAHAAdmin: false,
      dialogVisible: '', // 弹窗公共的判断
      editDialog: false, // 修改弹窗
      voidDialog: false, // 作废弹窗
      accountDialog: false, // 成本核算弹窗
      // 优惠券修改的表单
      editForm: {
        couponId: undefined,
        stock: '', // 优惠券库存
        detail: ''// 使用说明
      },
      editRules: {
        stock: [
          { required: true, message: '请输入优惠券库存', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入使用说明', trigger: 'blur' }
        ]
      },
      voidForm: {
        couponId: undefined,
        cancelledDetail: ''// 作废原因
      },
      voidRules: {
        detail: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ]
      },
      url: '/admin/coupon/getCouponList',
      query: [
        {
          label: '优惠券名称',
          prop: 'couponName',
          placeholder: '请输入优惠券名称'
        }, {
          label: '承担方',
          prop: 'costId',
          placeholder: '请选择承担方',
          type: 'select3',
          data: [],
          remoteMethod: (val) => {
            this.loadUndertaker(val)
          }
        }, {
          label: '优惠券种类',
          prop: 'type',
          placeholder: '请选择优惠券种类',
          type: 'select',
          data: [{
            'label': '现金券',
            'value': '1'
          }, {
            'label': '折扣券',
            'value': '2'
          }]
        }, {
          label: '抵扣费用类型',
          prop: 'limitType',
          placeholder: '请选择抵扣费用类型',
          type: 'select',
          data: [{
            'label': '服务费',
            'value': '1'
          }, {
            'label': '电费',
            'value': '2'
          }, {
            'label': '总费用',
            'value': '3'
          }]
        }, {
          label: '状态',
          prop: 'status',
          placeholder: '请选择状态',
          type: 'select',
          data: [{
            'label': '正常',
            'value': '0'
          }, {
            'label': '作废',
            'value': '-1'
          }],
          value: '1'
        }
      ],
      columns: [
        {
          label: '优惠券名称',
          prop: 'couponName'
        },
        {
          label: '优惠券种类',
          prop: 'type',
          template: function(index, record) {
            return record.type === 1 ? '现金券' : '折扣券'
          }
        },
        {
          label: '抵扣费用类型',
          prop: 'limitType',
          template: function(index, record) {
            if (record.limitType === 1) {
              return '服务费'
            } else if (record.limitType === 2) {
              return '电费'
            } else if (record.limitType === 3) {
              return '总费用'
            }
          }
        },
        {
          label: '面额/折扣',
          prop: 'couponData',
          template: function(index, record) {
            const newData = JSON.parse(record.couponData)
            if (record.type === 1) {
              return newData.amount + '元'
            } else if (record.type === 2) {
              return newData.discount + '%'
            }
          }
        },
        {
          label: '总数量',
          prop: 'totalNum'
        },
        {
          label: '已领数量',
          prop: 'sendNum'
        },
        {
          label: '已核销数量',
          prop: 'usedNum'
        },
        {
          label: '使用说明',
          prop: 'detail'
        },
        {
          label: '修改人',
          prop: 'updateByName'
        },
        {
          label: '修改时间',
          prop: 'updateTime',
          width: '150px'
        },
        {
          label: '作废原因',
          prop: 'cancelledDetail'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'coupons.manage.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'couponManagerAdd',
              query: {
                isDisabled: 0
              }
            })
          }
        },
        {
          label: '发放',
          icon: ' ',
          permission: 'coupons.manage.grant',
          type: 'primary',
          before: records => {
            console.log('选中的所有的数据', records)
            this.$router.push({
              path: 'couponIssuance'
            })
          }
        }
      ],
      handles: {
        width: 400,
        btns: [
          {
            label: '优惠券详情',
            permission: 'coupons.manage.hand.out',
            before: (index, record) => {
              console.log('点击详情', record)
              this.$router.push({
                path: 'couponDetail',
                query: {
                  isDisabled: 1,
                  data: record
                }
              })
            }
          },
          {
            label: '发放明细',
            permission: 'coupons.manage.release.details',
            before: (index, record) => {
              const data = {
                'couponId': record.couponId
              }
              this.$router.push({
                path: 'couponIssuanceDetails',
                query: data
              })
            }
          },
          {
            label: '修改',
            permission: 'coupons.manage.update',
            before: (index, record) => {
              this.dialogVisible = '修改'
              this.editDialog = true
              this.editForm.couponId = record.couponId
              this.editForm.stock = record.stock
              this.editForm.detail = record.detail
            }
          },
          {
            label: '作废',
            permission: 'coupons.manage.cancellation',
            style: 'color:red',
            getLabel: record => {
              return record.status === 0 ? '作废' : '已作废'
            },
            getLabelDisabled: record => {
              return record.status !== 0
            },
            before: (index, record) => {
              this.dialogVisible = '作废'
              this.voidDialog = true
              this.voidForm.couponId = record.couponId
            }
          }, {
            label: '复制',
            permission: 'coupons.manage.duplication',
            before: (index, record) => {
              const couponData = JSON.parse(record.couponData)
              const infoObj = {
                couponName: record.couponName,
                type: record.type,
                discount: couponData.discount || '',
                amount: couponData.amount || '',
                couponNum: record.totalNum,
                limitAmount: couponData.limitAmount
              }
              const undertaker = {
                underArray: JSON.parse(record.cost)
              }

              const limitObj = JSON.parse(record.limitTimeData)
              const useLimitObj = {
                deductionType: record.limitType,
                amount: record.limitPrice,
                useTime: record.limitTime,
                relativeTime: record.limitTime === 1 ? record.limitTimeData : '',
                useDate: record.limitTime === 1 ? [] : [limitObj.startTime, limitObj.endTime],
                useExplain: record.detail,
                partakeStation: record.useType,
                operator: record.useType === 1 ? record.useData.split(',') : [],
                station: record.useType === 2 ? record.useData.split(',') : []
              }
              const useDataName = record.useDataName
              const data = {
                infoObj: infoObj,
                undertaker: undertaker,
                useLimitObj: useLimitObj,
                useDataName: useDataName
              }
              this.$router.push({
                path: 'couponManagerAdd',
                query: {
                  isDisabled: 0,
                  data: data
                }
              })
            }
          }, {
            label: '成本核算',
            permission: 'coupons.manage.cost.accounting',
            before: (index, record) => {
              this.dialogVisible = '成本核算'
              this.accountDialog = true
              this.accountUrl = '/admin/coupon/getCost?couponId=' + record.couponId
            }
          }
        ]
      },
      accountUrl: '',
      accountColumns: [
        {
          label: '承担方',
          prop: 'orgName' // 字段名
        }, {
          label: '承担比例',
          prop: 'cost' // 字段名
        }, {
          label: '预计最高成本（元）',
          prop: 'maxAmount' // 字段名
        }, {
          label: '预计产生成本（元）',
          prop: 'preAmount' // 字段名
        }, {
          label: '实际产生成本（元）',
          prop: 'amount', // 字段名
          template: (index, reocrd) => {
            return this.getFloat(reocrd.amount)
          }
        }
      ]
    }
  },
  computed: {},
  watch: {
    formData: {
      handler(newV, oldV) {
        const o = this.$refs['dataForm']
        if (o) {
          o.clearValidate()
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeMount() {
    this.$store.dispatch('login/getCur', resp => {
      this.isAHAAdmin = resp.isAHAAdmin
    })
    this.loadUndertaker()
  },
  mounted() {
  },
  methods: {
    isInteger(value) {
      if (!value) {
        return false
      }
      if (!Number(value)) {
        return false
      } else {
        const re = /^[0-9]*[1-9][0-9]*$/
        const rsCheck = re.test(value)
        if (rsCheck) {
          return true
        } else {
          return false
        }
      }
    },
    // 加载承担方数据
    loadUndertaker(val) {
      const data = {
        name: val,
        pageNo: 1,
        pageSize: 100
      }
      this.$store.dispatch('form/handle', {
        url: '/org/page',
        data: data,
        callback: resp => {
          console.log('请求到的承担方数据：', resp)
          this.query[1].data = resp.list
        }
      })
    },
    // 修改弹窗的提交
    editSubmit() {
      if (!this.isInteger(this.editForm.stock)) {
        this.$notify.warning({
          title: '警告',
          message: '填写正确的库存'
        })
        return
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/edit',
        method: 'post',
        data: this.editForm,
        callback: resp => {
          this.editDialog = false
          this.$refs.tableref.queryTable()
        }
      })
    },
    // 作废弹窗的提交
    voidSubmit() {
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/cancel',
        method: 'post',
        data: this.voidForm,
        callback: resp => {
          this.dialogVisible = '作废'
          this.voidForm.cancelledDetail = ''
          this.voidDialog = false
          this.$refs.tableref.queryTable()
        }
      })
    },
    // 返回首页
    cancel() {
      // 关闭所有的弹窗
      this.dialogVisible = ''
      this.editDialog = false
      this.voidDialog = false
      this.accountDialog = false
    }
  }
}
</script>

<style lang="less" src="" scoped>
.flexJCenter {
  display: flex;
  justify-content: center;
}

.mt-25 {
  margin-top: 25px;
}

.el-tree {
  max-height: 200px;
  overflow: auto;
}

.el-input-group__append {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/discount/CouponManager.vue